import { Nullable } from 'common-types';
import EmailVerificationStore from '../stores/email-verification-store';

export const setIsLoadingVerificationEmail = (isLoading: boolean) => {
  EmailVerificationStore.isLoading = isLoading;
};

export const setEmailVerificationError = (errorMessage: Nullable<string>) => {
  EmailVerificationStore.emailVerificationError = errorMessage;
};
